import type { ConfidenceView } from "@/lib/attributeReview/rowChips";
import { cn } from "@/lib/utils";

const DOT: Record<ConfidenceView["tone"], string> = {
  good: "bg-emerald-500",
  plain: "bg-slate-400",
  amber: "bg-amber-500",
  none: "bg-slate-300 dark:bg-slate-600",
};

const TEXT: Record<ConfidenceView["tone"], string> = {
  good: "text-emerald-700 dark:text-emerald-300",
  plain: "text-slate-700 dark:text-slate-300",
  amber: "text-amber-700 dark:text-amber-300",
  none: "text-slate-400 dark:text-slate-500",
};

export function ConfidenceChip({
  view,
  short = false,
}: {
  view: ConfidenceView;
  short?: boolean;
}) {
  return (
    <span
      title={view.title}
      className={cn(
        "inline-flex items-center gap-1.5 text-xs font-medium",
        TEXT[view.tone],
      )}
    >
      <span
        aria-hidden
        className={cn("h-2 w-2 shrink-0 rounded-full", DOT[view.tone])}
      />
      {short ? view.short : view.text}
    </span>
  );
}
